import angular, { IScope, ITimeoutService } from 'angular';
import uiRouter, { StateService } from '@uirouter/angularjs';
import { TODO } from '@b2b/types/core/utils';
import { ApiService } from '@b2b/common/services/api/types';

ManageSecondaryContactModalController.$inject = [
  '$scope',
  '$state',
  '$timeout',
  '$uibModalInstance',
  'ApiService',
  'ValidateService',
  'contact',
  'address',
  'organizationId',
  'organizationName',
  'alertMessage',
];

function ManageSecondaryContactModalController(
  $scope: IScope & { manageSecondaryContactModal: TODO },
  $state: StateService,
  $timeout: ITimeoutService,
  $uibModalInstance: TODO,
  ApiService: ApiService,
  ValidateService: TODO,
  contact: TODO,
  address: TODO,
  organizationId: TODO,
  organizationName: TODO,
  alertMessage: TODO
) {
  const ctrl = {
    title: 'Add Contact',

    errors: [] as TODO[],

    isSubmitted: false,

    model: {} as TODO,

    createAddress: false,
    address: false as TODO,

    viewId: $state.current.name,

    loadPreferences: $state.current.data.enablePreferences,
    organizationId: '',
    organizationName: '',
    alertMessage: '',


    init: function () {
      if (contact) {
        ctrl.title = 'Edit contact';
        ctrl.model = contact;
      }

      if (organizationId) {
        ctrl.organizationId = organizationId;
      }

      if (organizationName) {
        ctrl.organizationName = organizationName;
      }

      if (!address) {
        if (contact && contact.id) {
          ctrl.getContactAddress(contact.id);
        }
      } else {
        ctrl.address = address;
      }

      if (alertMessage) {
        ctrl.alertMessage = alertMessage;
      }

      $scope.$on('AddressCreate::Close', ctrl.onAddressCreateClose);
      $scope.$on('AddressCreate::Complete', ctrl.onAddressCreateComplete);
      $scope.$on('AddressList::Create', ctrl.onAddressListCreate);
      $scope.$on('AddressList::Select', ctrl.onAddressListSelect);
      $scope.$on('AddressList::Edit', ctrl.onAddressListEdit);
    },

    getContactAddress: function (contactId) {
      ApiService.organizations.contacts
        .detail({
          organizationId: ctrl.organizationId,
          contactId: contactId,
        })
        .then(ctrl.success.getAddress, ctrl.error.getAddress);
    },

    isValid: function (field) {
      let r: TODO = true;

      if (ctrl.isSubmitted) {
        r = ValidateService.validate([
          {
            len: {
              value: ctrl.model[field],
            },
          },
        ]);
      }
      return r;
    },

    isValidEmail: function (email) {
      let r: TODO = true;

      if (ctrl.isSubmitted) {
        r = ValidateService.validate([{ email: email }]);
      }
      return r;
    },

    isValidPhone: function (phone) {
      let r: TODO = true;
      if (ctrl.isSubmitted) {
        r = ValidateService.validate([{ phone: phone }]);
      }
      return r;
    },

    prepareAddress: function () {
      ctrl.model.addressId = ctrl.address.addressId;
      ctrl.model.streetAddress1 = ctrl.address.streetAddress1;
      ctrl.model.streetAddress2 = ctrl.address.streetAddress2;
      ctrl.model.city = ctrl.address.city;
      ctrl.model.state = ctrl.address.state;
      ctrl.model.zipCode = ctrl.address.zipCode;
      ctrl.model.country = ctrl.address.country;
      ctrl.model.isPrimary = ctrl.address.isPrimary;
    },

    done: function () {
      let validators: TODO = [];

      ctrl.isSubmitted = true;
      $scope.$broadcast('AddressCreate::Check');
      ctrl.prepareAddress();

      validators = [
        { len: { value: ctrl.model.firstName } },
        { len: { value: ctrl.model.lastName } },
        { email: ctrl.model.email },
        { phone: ctrl.model.phoneNumber },
        { len: { value: ctrl.model.country } },
        { len: { value: ctrl.model.streetAddress1 } },
        { len: { value: ctrl.model.city } },
        { len: { value: ctrl.model.zipCode } },
      ];

      if (ctrl.model.country && (ctrl.model.country === 'Canada' || ctrl.model.country === 'United States')) {
        validators.push({ len: { value: ctrl.model.state } });
      }

      if (ValidateService.validate(validators)) {
        $uibModalInstance.close(ctrl.model, ctrl.address);
      } else {
        ctrl.errors = [{ message: 'Please correct the errors below.' }];
      }
    },

    cancel: function () {
      $uibModalInstance.dismiss('cancel');
    },

    success: {
      getAddress: function (response) {
        ctrl.createAddress = false;
        ctrl.address = response.data.payload;
        ctrl.prepareAddress();
      },
    },

    error: {
      getAddress: function (response) {
        console.error('Error retrieving contact address:', response);
      },
    },

    onAddressCreateComplete: function (e, data) {
      ctrl.errors = [];

      if (data.select) {
        ctrl.createAddress = false;
        ctrl.address = data.address;
        ctrl.prepareAddress();
      }
      $scope.$broadcast('AddressList::Refresh', { address: ctrl.address });
    },

    onAddressCreateClose: function (e, data) {
      $scope.manageSecondaryContactModal.createAddress = false;
    },

    onAddressListEdit: function (e, data) {
      ctrl.address = data.address;
      ctrl.createAddress = true;
    },

    onAddressListCreate: function (e, data) {
      ctrl.address = {
        country: '',
        type: 'secondary',
      };

      ctrl.createAddress = true;
    },

    onAddressListSelect: function (e, data) {
      if (data.selected) {
        ctrl.address = data.address;
      }
    },
  }

  $scope.manageSecondaryContactModal = ctrl;

  ctrl.init();
}

export const ManageSecondaryContactModalModule = angular
  .module('acme.view.application.partners.create.manageSecondaryContactModal.controllers', [
    uiRouter,
    'acme.common.service.api',
    'acme.common.service.validate',
  ])
  .controller('ManageSecondaryContactModalController', ManageSecondaryContactModalController).name;
